import { RoadrunnerFigure, a11yProps, palette as P } from './RoadrunnerMark';

type Props = { className?: string; title?: string };

const wood = '#8f6f4c';
const cork = '#e6cf9f';

/** Empty feed: the roadrunner visiting a trailhead-style board with one note pinned up. */
export function EmptyBoard({ className, title }: Props) {
  const line = {
    stroke: P.ink,
    strokeWidth: 2.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  } as const;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 280 180"
      width="100%"
      className={className}
      style={{ maxWidth: 320, display: 'block' }}
      {...a11yProps(title)}
    >
      {title && <title>{title}</title>}
      {/* sky: sun disc and a far ridge */}
      <circle cx={82} cy={84} r={40} fill={P.mustardSoft} />
      <path
        d="M0 124 L18 112 L30 116 L52 98 L66 104 L84 94 L104 106 L126 100 L150 108 L176 96 L196 104 L220 94 L244 104 L262 100 L280 108 L280 150 L0 150 Z"
        fill={P.dusk}
        opacity={0.22}
      />
      {/* ground */}
      <path d="M0 150 Q70 145 140 148 T280 147 L280 180 L0 180 Z" fill={P.board} />
      <path d="M6 150 Q70 145 140 148 T274 147" fill="none" {...line} strokeWidth={2.2} stroke={P.inkSoft} />
      <path
        d="M40 160 h10 M118 166 h6 M198 162 h12 M250 170 h7"
        fill="none"
        {...line}
        strokeWidth={1.8}
        stroke={P.inkSoft}
        opacity={0.5}
      />

      <g transform="translate(176 150) scale(0.9) translate(-170 -150)">
        {/* board posts */}
        <path d="M138 110 V150 M202 110 V150" fill="none" {...line} strokeWidth={8.6} />
        <path d="M138 110 V150 M202 110 V150" fill="none" stroke={wood} strokeWidth={4} strokeLinecap="round" />
        {/* panel */}
        <rect x={124} y={62} width={92} height={54} rx={3} fill={wood} {...line} />
        <rect x={130} y={68} width={80} height={42} rx={1.5} fill={cork} {...line} strokeWidth={2} />
        {/* little roof, park-service green */}
        <path d="M116 64 L170 44 L224 64 Z" fill={P.forest} {...line} />
        <path
          d="M128 60 L170 48.6 L212 60"
          fill="none"
          stroke={P.sage}
          strokeWidth={1.6}
          strokeLinecap="round"
          opacity={0.7}
        />
        {/* the one pinned note */}
        <g transform="rotate(-4 170 89)">
          <rect x={153} y={74} width={34} height={30} rx={1.5} fill={P.card} {...line} strokeWidth={2} />
          <path
            d="M159 86 h22 M159 92 h22 M159 98 h13"
            fill="none"
            stroke={P.inkSoft}
            strokeWidth={1.8}
            strokeLinecap="round"
            opacity={0.6}
          />
          <circle cx={170} cy={78.6} r={2.8} fill={P.adobe} stroke={P.ink} strokeWidth={1.4} />
        </g>
      </g>

      {/* prickly pear */}
      <g transform="translate(4 0)" {...line} strokeWidth={2.2}>
        <ellipse cx={237} cy={117} rx={8} ry={11} transform="rotate(-24 237 117)" fill={P.sage} />
        <ellipse cx={257} cy={119} rx={7.5} ry={10} transform="rotate(26 257 119)" fill={P.sage} />
        <ellipse cx={247} cy={135} rx={11} ry={15} fill={P.sage} />
        <ellipse
          cx={232.4}
          cy={104.4}
          rx={2.6}
          ry={3.4}
          transform="rotate(-24 232.4 104.4)"
          fill={P.adobe}
          strokeWidth={1.6}
        />
        <ellipse
          cx={262}
          cy={108.2}
          rx={2.6}
          ry={3.4}
          transform="rotate(26 262 108.2)"
          fill={P.adobe}
          strokeWidth={1.6}
        />
      </g>
      <g transform="translate(4 0)" fill={P.forest} opacity={0.75}>
        <circle cx={243} cy={128} r={0.9} />
        <circle cx={251} cy={134} r={0.9} />
        <circle cx={244} cy={141} r={0.9} />
        <circle cx={252} cy={144} r={0.9} />
        <circle cx={236} cy={113} r={0.9} />
        <circle cx={239} cy={119} r={0.9} />
        <circle cx={256} cy={115} r={0.9} />
        <circle cx={258} cy={122} r={0.9} />
      </g>

      {/* the roadrunner, walking up to have a look */}
      <RoadrunnerFigure transform="translate(18 61.2) scale(1.56)" detailed />
    </svg>
  );
}
